export default function setCookie(name, value, vm) {
  if (value === null || value === "" || value === []) {
    vm.$cookies.remove(name);
  } else {
    vm.$cookies.set(name, value);
  }
}
